//*react- recursosimemu
import React, { useState } from "react";

//*clases
//import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import { Col, Row } from "react-bootstrap";

//*archivos
import imemu from "./menu2.png";
import icontenido from "./solicitud.png";
//import { mdiMenuLeft } from "@mdi/js";

import ParteContenido from "./ParteContenido";
import ParteMenu from "./ParteMenu";

//*clases
import "./menuVertical.css";

//*interfaces
interface PropsMenuV {
  lado: any;
  menu: any;
}

//*componente
export default function GeneraMenu(props: PropsMenuV) {
  //*api store
  //*store's
  //*datos

  //*constantes y variables
  let menu = props.menu;
  let lado = props.lado;

  const [show, setShow] = useState(true);

  //*usestate
  //si es d es 9,2 si es i es 2,9
  let pContenido = 9;
  let pMenu = 3;

  //*vista
  return (
    <>
      <br />
      <div>
        Ejemplo con un archivo insumo en datos/menu1.json <br />
        <br />
      </div>
      <div className={lado === "i" ? "posIzquierda " : "posDerecha "}>
        {show && <div id="divintSolMicro">Solicitud de microdatos </div>}
        <div id="idImg">
          <img
            src={imemu}
            alt="imemu"
            onClick={() => {
              setShow(!show);
            }}
            id="img"
          />
        </div>
      </div>

      {/*fondo blanco className="containerContent"*/}
      {show ? (
        <div className="container-fluid divCont">
          {lado === "d" ? (
            <div id="pder">
              <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                {/*Derecha"*/}
                <Row>
                  <Col sm={pContenido} className="pContenido">
                    <ParteContenido menu={menu} />
                  </Col>
                  <Col sm={pMenu} className="pMenu">
                    <ParteMenu menu={menu} />
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          ) : (
            <div id="pizq" style={{ marginRight: "790px" }}>
              <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                {/*Izquierda"*/}
                <Row>
                  <Col sm={pMenu} className="pMenu">
                    <ParteMenu menu={menu} />
                  </Col>
                  <Col
                    sm={pContenido}
                    className="pContenido"
                    style={{
                      marginRight: "-1200px",
                    }}
                  >
                    <ParteContenido menu={menu} />
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          )}
          <br />
          <br />
        </div>
      ) : (
        <>
          <div>
            <img src={icontenido} alt="icont" />
          </div>
        </>
      )}
    </>
  );
}
